import { SetUpData } from "../../../data/admin-data"

interface SetUpTHeadProps {
    data: SetUpData[]
}

export default function SetupTHead({ data }: SetUpTHeadProps) {
    return (
        <thead className='bg-gray-50 text-black uppercase text-xs sticky top-0'>
            <tr className='bg-gray-300 text-gray-900'>
                {data.map((header, index) => (
                    <th key={index} className={`px-2.5 py-1.5 text-left border border-gray-200`}>
                        {header.name}
                    </th>
                ))}
            </tr>
        </thead>
    )
}
